import { Add, Search } from '@mui/icons-material';
import {
	Button,
	Container,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { Placeholder, SortableTableHeader, Subheader } from 'components';
import { useAlerts, useNavigation, useSelected } from 'hooks';
import AcademyItem from './AcademyItem';
import { useNavigate } from 'react-router-dom';
import useAcademies from 'hooks/useAcadamies';
import { useEffect } from 'react';

const TABLE_HEADERS = [
	{
		value: 'image_url',
		label: 'Image',
		sortable: true,
		hidden: false
	},

	{
		value: 'title',
		label: 'Title',
		sortable: true,
		hidden: false
	},
	{
		value: 'description',
		label: 'Description',
		sortable: true,
		hidden: true
	},
	{
		value: 'created_at',
		label: 'Created At',
		sortable: true,
		hidden: false
	}
];

const AcademyList = () => {
	const navigate = useNavigate();
	const { showAlertSuccess } = useAlerts();
	const { handleClick, handleEditClick } = useNavigation({
		history,
		url: '/academies'
	});
	const {
		findAcademies,
		academies,
		page,
		sortKey,
		sortDirection,
		isEmpty,
		reloadAcademies,
		deleteAcademy
	} = useAcademies({});

	const handleDeleteClick = async (academy) => {
		await deleteAcademy(academy);
		showAlertSuccess('Academy has been deleted');
		reloadAcademies();
	};

	const handleAddClick = () => {
		navigate('/academy/new');
	};
	const handleSort = () => {};

	useEffect(() => {
		findAcademies({
			sort_key: sortKey,
			sort_direction: sortDirection
		});
	}, [page, sortKey, sortDirection]);

	return (
		<div>
			<Subheader
				title="Academies"
				buttons={[
					<Button
						variant="contained"
						startIcon={<Add />}
						onClick={handleAddClick}
						color="primary"
					>
						Academy
					</Button>
				]}
			/>

			<Container maxWidth="lg">
				<Paper>
					{!isEmpty ? (
						<TableContainer component={Paper} elevation={0}>
							<Table>
								<TableHead>
									<TableRow>
										{TABLE_HEADERS.filter((h) => !h.hidden).map(
											(header, idx) => (
												<SortableTableHeader
													key={idx}
													handleSort={handleSort}
													value={`academies.${header.value}`}
												>
													{header.label}
												</SortableTableHeader>
											)
										)}
										<TableCell></TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{academies.map((academy, index) => (
										<AcademyItem
											academy={academy}
											key={`academy_id_${index}`}
											handleClick={handleClick}
											handleEditClick={handleEditClick}
											handleDeleteClick={handleDeleteClick}
										/>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					) : (
						<Placeholder icon={<Search />} title="No Academies" />
					)}
				</Paper>
			</Container>
		</div>
	);
};

export default AcademyList;
